const texts = {
  pooledTitle: '{coach} is in the coach pool',
  pooledDescription: 'Served by the whole AC organization — no dedicated AC. Removing them from the pool requires '
    + 'assigning one.',
  dedicatedAcTitle: '{coach} is with a dedicated AC',
  dedicatedAcsTitle: '{coach} is with {count} dedicated ACs',
  dedicatedAcDescription: 'AC: {acNames}. Moving them to the pool removes that AC assignment — a coach is never both.',
  dedicatedAcsDescription: 'ACs: {acNames}. Moving them to the pool removes all {count} AC assignments — a coach is '
    + 'never both.',
  // A coach without Assistant Coaching can't be pooled, so their card leaves the pool out.
  dedicatedAcIneligibleDescription: 'AC: {acNames}.',
  dedicatedAcsIneligibleDescription: 'ACs: {acNames}.',
  unassignedTitle: '{coach} has no AC assignment',
  unassignedDescription: 'Assign a dedicated AC below, or move them to the pool so the whole AC organization can '
    + 'work them.',
  unassignedIneligibleDescription: 'Assign a dedicated AC below. Turn on Assistant Coaching to make them eligible for '
    + 'the pool.',
};

export default texts;
